import CompanyContact from 'components/company/CompanyTable/CompanyContact';
import CompanyId from 'components/company/CompanyTable/CompanyId';
import CompanyLifecycle from 'components/company/CompanyTable/CompanyLifecycle';
import CompanyName from 'components/company/CompanyTable/CompanyName';
import CompanyNumber from 'components/company/CompanyTable/CompanyNumber';
import CompanyRisk from 'components/company/CompanyTable/CompanyRisk';

export const SORTING = {
  ID: 'ID',
  COMPANY_NAME: 'COMPANY_NAME',
  COMPANY_TYPE: 'COMPANY_TYPE',
  CONTACT_NAME: 'CONTACT_NAME',
  CONTACT_EMAIL: 'CONTACT_EMAIL',
  LIFECYCLE: 'LIFECYCLE',
  FLAG: 'FLAG',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const TABLE_COLUMNS = [
  {
    Header: 'Risk',
    accessor: 'companyRisk',
    subAccessors: ['id'],
    items: [
      {
        action: {
          type: 'companyFlag-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort Flag',
      },
    ],
    renderComponent: {
      component: CompanyRisk,
      value: 'flag',
      optionalProps: ['id'],
    },
    width: 45,
    minWidth: 45,
    maxWidth: 45,
  },
  {
    Header: 'Company',
    accessor: 'companyName',
    subAccessors: ['companyType'],
    items: [
      {
        action: {
          type: 'company-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort company name',
      },
      {
        action: {
          type: 'company-type-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort company type',
      },
    ],
    renderComponent: {
      component: CompanyName,
      value: 'name',
      optionalProps: ['type'],
    },
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'ID',
    accessor: 'id',
    items: [
      {
        action: {
          type: 'id-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort ID',
      },
    ],
    renderComponent: {
      component: CompanyId,
      value: 'id',
    },
    width: 280,
    minWidth: 100,
    maxWidth: 300,
  },
  {
    Header: 'Type',
    accessor: 'type',
    items: [
      {
        action: {
          type: 'type-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort by type',
      },
    ],
    renderComponent: {
      component: CompanyId,
      value: 'id',
    },
    width: 80,
    minWidth: 40,
    maxWidth: 300,
  },
  {
    Header: 'Number',
    accessor: 'companyNumber',
    items: [
      {
        action: {
          type: 'company-number-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort Number',
      },
    ],
    renderComponent: {
      component: CompanyNumber,
      value: 'companyNumber',
    },
    width: 150,
    minWidth: 100,
    maxWidth: 240,
  },
  {
    Header: 'Contact',
    accessor: 'contactName',
    subAccessors: ['contactEmail', 'contactPhone'],
    items: [
      {
        action: {
          type: 'name-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort name',
      },
      {
        action: {
          type: 'email-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort email',
      },
    ],
    renderComponent: {
      component: CompanyContact,
      value: 'name',
      optionalProps: ['email', 'phone'],
    },
    width: 200,
    minWidth: 100,
    maxWidth: 400,
  },
  {
    Header: 'Lifecycle',
    accessor: 'lifecycle',
    items: [
      {
        action: {
          type: 'lifecycle-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort Lifecycle',
      },
    ],
    renderComponent: {
      component: CompanyLifecycle,
      value: 'lifecycle',
    },
    width: 150,
    minWidth: 100,
    maxWidth: 240,
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const SEARCH_OPTIONS = {
  keys: [
    { name: 'id', weight: 1 },
    { name: 'lifecycle', weight: 1 },
    { name: 'companyName', weight: 1 },
    { name: 'companyType', weight: 1 },
    { name: 'contactName', weight: 1 },
    { name: 'contactEmail', weight: 1 },
    { name: 'contactPhone', weight: 1 },
    { name: 'directorEmails', weight: 1 },
    { name: 'directorPhones', weight: 1 },
    { name: 'referral', weight: 1 },
    { name: 'type', weight: 1 },
    { name: 'companyNumber', weight: 1 },
    { name: 'companyFlag', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};
